// Импортируйте axiosInstance, если он вам нужен
import axiosInstance from '../../helpers/instance';

const state = {
  main: null,
  about: null,
  services: null,
  service: null,
  products: null,
  product: null,
  projects: null,
  project: null,
  news: null,
  newsMoree: null,
  newsDetail: null,
  newsCategory: [{
    name: 'test',
    slug: 'test',
  }],
  contacts: null,
};

const getters = {
};

const actions = {
  async getMain({ commit }, payload) {
    try {

      const response = await axiosInstance.get('/api/home/', {
        headers: {
          'Accept-Language': payload.lang
        }
      });

      if (response.data) {
        commit('setMain', response.data);
        // console.log(response.data)
      }

      return response.data;
    } catch (error) {
      console.log('Ошибка:', error);
      throw error;
    }
  },
  async getAbout({ commit }, payload) {
    try {
      const response = await axiosInstance.get('/api/about/', {
        headers: {
          'Accept-Language': payload.lang
        }
      });

      if (response.data) {
        commit('setAbout', response.data);
        // console.log(response.data);
      }
    } catch (error) {
      console.log('Ошибка', error);
      throw error;
    }
  },
  async getServices({ commit }, payload) {
    try {
      const response = await axiosInstance.get('/api/services/', {
        headers: {
          'Accept-Language': payload.lang
        }
      });

      if (response.data) {
        commit('setServices', response.data);
        // console.log(response.data);
      }
    } catch (error) {
      console.log('Ошибка', error);
      throw error;
    }
  },
  async getService({ commit }, payload) {
    try {
      const response = await axiosInstance.get('/api/services/' + payload.slug, {
        headers: {
          'Accept-Language': payload.lang
        }
      });

      if (response.data) {
        commit('setService', response.data);
        // console.log(response.data.data);
      }
    } catch (error) {
      console.log('Ошибка', error);
      throw error;
    }
  },
  async getProducts({ commit }, payload) {
    try {
      var response;
      if (payload.slug === null || payload.slug === undefined) {
        response = await axiosInstance.get('/api/products/', {
          headers: {
            'Accept-Language': payload.lang
          }
        });
      }
      else {
        response = await axiosInstance.get(`/api/categories/${payload.slug}/products`, {
          headers: {
            'Accept-Language': payload.lang
          }
        });
      }

      if (response.data) {
        commit('setProducts', response.data);
        // console.log(response.data);
      }
    } catch (error) {
      console.log('Ошибка', error);
      throw error;
    }
  },
  async getProduct({ commit }, payload) {
    try {
      // const response = await axiosInstance.get('/api/product/' + payload.id);
      const response = await axiosInstance.get('/api/products/' + payload.id, {
        headers: {
          'Accept-Language': payload.lang
        }
      });

      if (response.data) {
        commit('setProduct', response.data);
        // console.log(response.data.data);
      }
    } catch (error) {
      console.log('Ошибка', error);
      throw error;
    }
  },
  async getProjects({ commit }, payload) {
    try {
      const response = await axiosInstance.get('/api/projects/', {
        headers: {
          'Accept-Language': payload.lang
        }
      });

      if (response.data) {
        commit('setProjects', response.data);
        // console.log(response.data)
      }

      return response.data;
    } catch (error) {
      console.log('Ошибка:', error);
      throw error;
    }
  },
  async getProject({ commit }, payload) {
    try {
      // const response = await axiosInstance.get('/api/product/' + payload.id);
      const response = await axiosInstance.get('/api/projects/' + payload.id, {
        headers: {
          'Accept-Language': payload.lang
        }
      });

      if (response.data) {
        commit('setProject', response.data);
        // console.log(response.data.data);
      }
    } catch (error) {
      console.log('Ошибка', error);
      throw error;
    }
  },
  async getNews({ commit }, payload) {
    try {
      const response = await axiosInstance.get('/api/news/', {
        headers: {
          'Accept-Language': payload.lang
        }
      });

      if (response.data) {
        commit('setNews', response.data);
        // console.log(response.data)
      }

      return response.data;
    } catch (error) {
      console.log('Ошибка:', error);
      throw error;
    }
  },
  async getNewsCategory({ commit }, payload) {
    try {
      const response = await axiosInstance.get('/api/news/categories', {
        headers: {
          'Accept-Language': payload.lang
        }
      });

      if (response.data) {
        commit('setNewsCategory', response.data);
        // console.log(response.data)
      }

      return response.data;
    } catch (error) {
      console.log('Ошибка:', error);
      throw error;
    }
  },
  async getNewsGetByCategory({ commit }, payload) {
    try {
      const response = await axiosInstance.get('/api/news?category=' + payload.category, {
        headers: {
          'Accept-Language': payload.lang
        }
      });

      if (response.data) {
        commit('setNews', response.data);
        // console.log(response.data)
      }

      return response.data;
    } catch (error) {
      console.log('Ошибка:', error);
      throw error;
    }
  },
  async getNewsMoree({ commit }, payload) {
    try {
      const response = await axiosInstance.get('/api/news/?page=' + payload.page, {
        headers: {
          'Accept-Language': payload.lang
        }
      });

      if (response.data) {
        commit('setNewsMoree', response.data);
        // console.log(response.data)
      }

      return response.data;
    } catch (error) {
      console.log('Ошибка:', error);
      throw error;
    }
  },
  async getNewsDetail({ commit }, payload) {
    try {

      // const response = await axiosInstance.get('/api/product/' + payload.id);
      const response = await axiosInstance.get('/api/news/' + payload.id, {
        headers: {
          'Accept-Language': payload.lang
        }
      });

      if (response.data) {
        commit('setNewsDetail', response.data);
        // console.log(response.data.data);
      }
    } catch (error) {
      console.log('Ошибка', error);
      throw error;
    }
  },
  async getContacts({ commit }, payload) {
    try {
      const response = await axiosInstance.get('/api/contacts/', {
        headers: {
          'Accept-Language': payload.lang
        }
      });

      if (response.data) {
        commit('setContact', response.data);
        // console.log(response.data);
      }
    } catch (error) {
      console.log('Ошибка', error);
      throw error;
    }
  },
  async postRequest({ commit }, payload) {
    try {
      const response = await axiosInstance.post('/api/form_request/', payload);

      if (response.data) {
        // commit('setMain', response.data);
        return response.data;
      }

    } catch (error) {
      throw error.response;
    }
  },
  async postRequestOther({ commit }, payload) {
    try {
      var response;
      if (payload.type === 'project') {
        response = await axiosInstance.post('/api/request/project/new', payload.data);
      }
      if (payload.type === 'service') {
        response = await axiosInstance.post('/api/request/service/new', payload.data);
      }
      if (payload.type === 'product') {
        response = await axiosInstance.post('/api/request/product/new', payload.data);
      }

      if (response.data) {
        // commit('setMain', response.data);
        return response.data;
      }

    } catch (error) {
      throw error.response;
    }
  },
  async postRequestModal({ commit }, payload) {
    try {
      var response;
      if (payload.type === 'products') {
        response = await axiosInstance.post('/api/request/product/new', payload.data);
      }
      else {
        response = await axiosInstance.post('/api/request/service/new', payload.data);
      }

      if (response.data) {
        // commit('setMain', response.data);
        return response.data;
      }

    } catch (error) {
      throw error.response;
    }
  },
};

const mutations = {
  setMain(state, data) {
    state.main = data;
  },
  setAbout(state, data) {
    state.about = data;
  },
  setServices(state, data) {
    state.services = data;
  },
  setService(state, data) {
    state.service = data;
  },
  setProducts(state, data) {
    state.products = data;
  },
  setProduct(state, data) {
    state.product = data;
  },
  setProjects(state, data) {
    state.projects = data;
  },
  setProject(state, data) {
    state.project = data;
  },
  setNews(state, data) {
    state.news = data;
  },
  setNewsCategory(state, data) {
    state.newsCategory = data;
  },
  setNewsMoree(state, data) {
    const oldData = Array.isArray(state.news?.data) ? state.news.data : [];
    const newData = Array.isArray(data?.data) ? data.data : [];

    const merged = [...oldData, ...newData].filter(
      (item, index, self) =>
        index === self.findIndex((t) => t.id === item.id)
    );

    state.newsMoree = oldData;
    state.news = {
      ...data,
      data: merged
    };
  },
  setNewsDetail(state, data) {
    state.newsDetail = data;
  },
  setContact(state, data) {
    state.contacts = data;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
